export const loadImage = (path) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'Anonymus';
        image.src = path;
        image.onload = () => resolve(image);
        image.onerror = (error) => reject(error);
    });
};
//# sourceMappingURL=ImageLoader.js.map